
<script>
import saleIcon from '@/assets/images/icons/sale.svg?inline'
import SaleFilters from './views/SaleFilters.vue'
import SaleForm from './views/SaleForm.vue'
import SaleCards from './ui/SaleCards.vue'
import SearchControls from '@/components/services/ui/searchControls.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'

export default {
  name: 'sale',
  components: {
    saleIcon,
    SaleFilters,
    SearchControls,
    SaleCards,
    SaleForm,
    infiniteScroll
  },
  metaInfo: {
    title: 'Горячие предложения'
  },
  computed: {
    isLoading() {
      return this.$store.getters['sale/isLoading']
    },
    isLoadingMore() {
      return this.$store.getters['sale/isLoadingMore']
    },
    isControls() {
      return this.$store.getters['sale/isControls']
    },
    pagination() {
      return this.$store.getters['sale/getPagination']
    },
    form() {
      return this.$store.getters['sale/getForm']
    },
    isCollectionEmpty() {
      return !this.isLoading && !this.$store.getters['sale/getCollection'].length
    },
    isModalActive() {
      return this.$store.getters['sale/getModalForm'].active
    },
  },
  created() {
    this.$store.commit('sale/setIsLoading', true)

    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'currencies',
        target: 'sale.dictionaries.currencies'
      }
    })

    this.$store.dispatch('sale/getCollection', this.form)
  },
  beforeDestroy() {
    this.$store.commit('sale/setInitialState')
  },
  methods: {
    loadMore() {
      this.$store.commit('sale/setIsLoadingMore', true)

      this.$store.dispatch('sale/getCollection', {
        ...this.form,
        page: this.pagination.page + 1
      })
    },
    sort() {
      this.$store.commit('sale/setIsLoading', true)
      this.$store.dispatch('sale/getCollection', this.form)
    },
    closeForm() {
      this.$store.commit('sale/updateModalForm', {
        active: false,
        mode: null
      })

      this.$store.commit('sale/clearEditForm')
      this.imageSrc = null
    }
  }
}
</script>

<template>
  <div class="sale">
    <h1 class="rex-title">
      <saleIcon />
      Горячие предложения
    </h1>
    <div class="rex-wrap">
      <div class="sale__content">
        <search-controls
          v-if="!isCollectionEmpty && isControls"
          store-module="sale"
          getter-fields-name="getForm"
          getter-field-name="getField"
          setter-field-name="setField"
          :hide-agent-price-toggler="true"
          :hide-view-type-changer="true"
          @sort="sort"
        />
        <div
          v-if="isCollectionEmpty"
          class="search-content__no-results"
        >
          <h2>
            Ничего не найдено<br>
            Попробуйте изменить настройки фильтров
          </h2>
        </div>
        <infinite-scroll
          v-else
          :pagination="pagination"
          :is-loading="isLoading || isLoadingMore"
          @loadMore="loadMore"
        >
          <sale-cards
            v-if="!isLoading"
          />
        </infinite-scroll>
      </div>
      <div>
        <sale-filters />
      </div>
    </div>
    <b-modal
      :active="isModalActive"
      scroll="keep"
      :can-cancel="['outside']"
      :width="1200"
      @close="closeForm"
    >
      <sale-form />
    </b-modal>
  </div>
</template>
